interface Concept {
    title: string;
    description: string;
    icon: string;
}

interface SolidPrinciple {
    letter: string;
    name: string;
    summary: string;
}

const oopConcepts: Concept[] = [
    { title: "Encapsulation", description: "Bundling data and methods that work on that data within one unit.", icon: "[O]" },
    { title: "Abstraction", description: "Hiding complex reality while exposing only the necessary parts.", icon: "[?]" },
    { title: "Inheritance", description: "A mechanism to derive a class from another class for code sharing.", icon: "[v]" },
    { title: "Polymorphism", description: "The ability of different classes to be treated as instances of the same general class.", icon: "[*]" }
];

const solidPrinciples: SolidPrinciple[] = [
    { letter: "S", name: "Single Responsibility", summary: "A class should have one, and only one, reason to change." },
    { letter: "O", name: "Open/Closed", summary: "Entities should be open for extension, but closed for modification." },
    { letter: "L", name: "Liskov Substitution", summary: "Derived classes must be substitutable for their base classes." },
    { letter: "I", name: "Interface Segregation", summary: "Many client-specific interfaces are better than one general-purpose interface." },
    { letter: "D", name: "Dependency Inversion", summary: "Depend on abstractions, not on concretions." }
];

function renderOOP(concepts: Concept[]): void {
    const container = document.getElementById('oop-content');
    if (!container) return;
    let html = '<table border="1" cellpadding="5" width="100%">';
    concepts.forEach(concept => {
        html += `<tr><td width="50" align="center" bgcolor="#eeeeee"><b><font size="+2">${concept.icon}</font></b></td><td><b>${concept.title}</b><br><font size="-1">${concept.description}</font></td></tr>`;
    });
    html += '</table>';
    container.innerHTML = html;
}

function renderSOLID(principles: SolidPrinciple[]): void {
    const container = document.getElementById('solid-content');
    if (!container) return;
    let html = '<ul>';
    principles.forEach(p => {
        html += `<li><font color="#000080"><b>${p.letter}</b> - ${p.name}</font>: ${p.summary}</li>`;
    });
    html += '</ul>';
    container.innerHTML = html;
}

class StatusBarTicker {
    private message: string = "Welcome to Evidica... Learning OOP is cool... Typescript is the future...      ";
    private position: number = 0;
    private speed: number = 150;

    constructor() { this.tick = this.tick.bind(this); }
    start() { setInterval(this.tick, this.speed); }
    tick() {
        document.title = this.message.substring(this.position) + this.message.substring(0, this.position);
        this.position++;
        if (this.position > this.message.length) this.position = 0;
    }
}

window.onload = () => {
    renderOOP(oopConcepts);
    renderSOLID(solidPrinciples);
    const ticker = new StatusBarTicker();
    ticker.start();
};